import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { FolderTree, ArrowLeft } from "lucide-react";
import NavBar from "@/library/components/NavBar";
import Footer from "@/library/components/Footer";
import Breadcrumbs from "@/library/components/Breadcrumbs";
import { api } from "@/library/lib/api";

const Domains = () => {
  const { levelId } = useParams();
  const [level, setLevel] = useState(null);
  const [domains, setDomains] = useState([]);

  useEffect(() => {
    api.get("/levels").then((r) => setLevel(r.data.find((l) => l.id === levelId)));
    api.get(`/domains?level_id=${levelId}`).then((r) => setDomains(r.data)).catch(() => {});
  }, [levelId]);

  return (
    <div data-testid="domains-page" className="min-h-screen flex flex-col">
      <NavBar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex-1 w-full">
        <Breadcrumbs items={[
          { label: "الرئيسية", to: "/" },
          { label: "المراحل", to: "/library/levels" },
          { label: level?.name || "..." }
        ]} />
        <div className="mb-10">
          <div className="text-gold-dark font-bold text-xs tracking-widest uppercase mb-2">{level?.name}</div>
          <h1 className="font-heading text-3xl md:text-4xl font-extrabold text-brand-dark">المجالات</h1>
          <div className="gold-line mt-3"></div>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {domains.map((d, i) => (
            <motion.div key={d.id} initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.06 }}>
              <Link to={`/library/domains/${d.id}`} data-testid={`domain-card-${d.id}`} className="premium-card p-6 block group h-full">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-xl bg-brand/8 text-brand flex items-center justify-center shrink-0 group-hover:bg-gold/15 group-hover:text-gold-dark transition-colors">
                    <FolderTree className="w-6 h-6" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-heading text-lg font-bold text-brand-dark mb-1">{d.name}</h3>
                    <p className="text-sm text-slate-500 leading-relaxed line-clamp-2">{d.description}</p>
                  </div>
                </div>
                <div className="mt-5 pt-4 border-t border-slate-100 text-gold-dark font-bold text-sm flex items-center gap-2 group-hover:gap-3 transition-all">
                  <span>عرض المؤشرات</span> <ArrowLeft className="w-4 h-4" />
                </div>
              </Link>
            </motion.div>
          ))}
          {domains.length === 0 && <div className="col-span-3 text-center py-16 text-slate-500">لا توجد مجالات</div>}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Domains;
